module.exports = __webpack_public_path__ + "9af218326c95cd3c6faee756fd87e29a.svg";